import { NgTemplateOutlet } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { ViewCompanyComponent } from 'components/company/viewcompany.component';
import { ViewTaskflowComponent } from 'components/task/taskflow/view-taskflow.component';
import { CredentialType } from 'enums/CredentialType';
import { HubAction } from 'enums/HubAction';
import { TaskflowStatus } from 'enums/TaskflowStatus';
import { TaskflowModel } from 'models/generated/Entities.GormCrm.Taskflow';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { UserPipe } from 'pipes/user.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';
import { PushService } from 'services/push.service';
import { TaskService } from 'services/task.service';

@Component({
	selector: 'list-taskflow',
	templateUrl: './list-taskflow.component.html',
	imports: [Layout, NgTemplateOutlet, ListView, TranslatePipe, CustomDatePipe, UserPipe]
})
@ComponentUrl('list-taskflow')
@CredentialRequired(CredentialType.BetaUserAccess)
export class ListTaskflowComponent implements OnDestroy {

	public completedStatus = TaskflowStatus.Completed;
	private _companyId = '';

	@UrlParam
	set companyId(id: string) {
		if (id) {
			this._companyId = id;
			this.updateListOfTaskflows();
			this.navigation.openNavigationView(this, 'company-related-views', ViewCompanyComponent).then(viewCompany => { viewCompany.companyId = id });
		}
	}
	get companyId() {
		return this._companyId;
	}

	allTaskflows: TaskflowModel[] = [];
	openTaskflows: TaskflowModel[] = [];
	closedTaskflows: TaskflowModel[] = [];
	onTaskflowChanges: Subscription;
	selectedTaskflowId?: string;
	isLoading = true;

	constructor(private readonly taskService: TaskService, private readonly pushService: PushService, private navigation: NavigationService) {
		
		this.onTaskflowChanges = this.pushService.onTaskflowChanges.subscribe(event => {
			if ((event.action == HubAction.Insert && event.data.companyId == this.companyId) || this.allTaskflows.filter(t => t.id === event.data.taskflowId).length > 0) {
				this.updateListOfTaskflows();
			}
		});
	}

	updateListOfTaskflows() {
		this.isLoading = true;

		this.taskService.getCompanyTaskflows(this.companyId).then((taskflows) => {

			this.allTaskflows = taskflows;
			this.openTaskflows = taskflows.filter(t => !t.completed && !t.parentTaskflowId);
			this.closedTaskflows = taskflows.filter(t => t.completed && !t.parentTaskflowId);

			this.isLoading = false;
		});
	}

	selectTaskflow(taskflowId: string) {
		this.selectedTaskflowId = taskflowId;
		this.navigation.openRelativeView(this, 'company-related-views', ViewTaskflowComponent).then(view => {
			view.taskflowId = this.selectedTaskflowId as string;
		});
	}

	ngOnDestroy() {
		this.onTaskflowChanges.unsubscribe();
	}
}
